/**
 * GlobalHelper: Copy to Clipboard
 * -------------------------------
 */

import {
    registerLegacySalvoLiteComponent,
    legacySalvoLiteLog as log
} from '@eastsideco/salvo-ts';

/**
 * Component Class
 */
class CopyToClipboard {
    constructor(theme, elem) {
        this._name = this.constructor.name;
        this._elem = elem;
        this._content = elem.getAttribute('data-copy-to-clipboard');
    }

    onInit() {
        this._elem.addEventListener('click', () => {
            window.prompt('Copy to clipboard: Ctrl/Cmd+C, Enter', this._content);
            log.info(this._name, 'Copied!');
        });

        log.debug(this._name, 'Initiated', this);
    }
}

/**
 * Export Call
 */
export default registerLegacySalvoLiteComponent({
    component: CopyToClipboard,
    selector: '[data-copy-to-clipboard]',
});
